import { List, useRecordContext } from "react-admin";
import { DrivingSchool } from "../../providers/drivingSchoolsProvider";
import { LoadingIndicator } from "../../misc/LoadingIndicator";
import { PageTitle } from "../../misc/PageTitle";
import { grants } from "../../backoffice.access_control";
import { useNavigate } from "react-router";
import { Row } from "../../misc/Row";
import { Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { EmptyState } from "../../misc/EmptyState";
import { ResponsiveListSurface } from "../../misc/ResponsiveListSurface";
import { ExamLocationsDataGrid } from "./ExamLocationsDataGrid";

export function DrivingSchoolExamLocations() {
  const drivingSchool = useRecordContext<DrivingSchool>();
  const navigate = useNavigate();

  if (!drivingSchool) {
    return (
      <>
        <PageTitle>Prüfungsorte</PageTitle>
        <LoadingIndicator />
      </>
    );
  }

  const empty = <EmptyState />;

  return (
    <div style={{ position: "relative" }}>
      <Row justifyContent="space-between" alignItems="center" sx={{ mb: "30px", minHeight: "32px" }}>
        <PageTitle documentTitle="Prüfungsorte">
          <h2 style={{ margin: 0, lineHeight: 0.83 }}>Prüfungsorte</h2>
        </PageTitle>
        {grants.has("ExamLocation:create") && (
          <Button
            variant="outlined"
            startIcon={<AddIcon />}
            onClick={() => navigate("/examLocations/create")}
            size="small"
          >
            Hinzufügen
          </Button>
        )}
      </Row>
      <ResponsiveListSurface variant="compactStandalone" data-testid="DrivingSchoolExamLocations">
        <List
          resource="examLocations"
          title=" "
          actions={false}
          filter={{ drivingSchoolId: drivingSchool.id, deleted: false }}
          sort={/* initial sort order: */ { field: "name", order: "ASC" }}
          exporter={false}
          hasCreate={false}
          empty={empty}
        >
          <ExamLocationsDataGrid empty={empty} />
        </List>
      </ResponsiveListSurface>
    </div>
  );
}
